import { Typography } from "@mui/material";
import { styled } from "@mui/material/styles";

export const RemovalConfirmationContainer = styled('div')(({ theme }) => ({
    display: "flex",
    alignSelf: "stretch",
    alignItems: "center",
    minHeight: "2.6rem",
    width: '100%',
    gap: theme.space._200,
}));

export const ButtonsContainer = styled('div')(({ theme }) => ({
    display: "flex",
    alignSelf: "stretch",
    justifyContent: "flex-end",
    gap: theme.space._200,
    flex: 1,
}));
